export function htmlDecode(encodedHtml: string) {
    var txt = document.createElement('textarea');
    txt.innerHTML = encodedHtml;
    return txt.value;
}